import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { UISchemaService } from './services/ui.schema.service'
import { AppComponent } from './app.component';
import { NgxModules } from '@ngxmodules';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';


@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        NgxModules,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            closeButton: true
        })
    ],
    providers: [
        UISchemaService,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
